export default "__VITE_ASSET__eUzoCacy__"